// To avoid cyclic dependency caused by importing stores, store hooks have been added to a different file

import { Instance } from "mobx-state-tree";
import { useRootStore } from "../../root/store/RootStore";
import { SignInStore } from "./SignInStore";

export const useSignInStore = (): Instance<typeof SignInStore> => {
  return useRootStore().signInStore;
};
